import { useState } from 'react'
import Files from 'react-files'
import { FaFileExcel, FaFileCsv, FaCloudUploadAlt } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import Dropdown from 'components/Form/Option/Dropdown'
import { campaign } from 'core/helpers'
import { CircularProgress } from '@material-ui/core'
import BackupIcon from '@material-ui/icons/Backup'

import {
  StepContent,
  ImportSection,
  SectionTitle,
  StepNumber,
  DropdownContainer,
  FileUploadContainer,
  FilesDropzone,
  UploadZone,
  UploadZoneContent,
  UploadText,
  UploadTitle,
  UploadSubtitle,
  FilePreview,
  FileIcon,
  FileInfo,
  FileName,
  RemoveFileButton,
  UploadButton,
  LoadingContainer,
  LoadingText,
  AcceptedFilesInfo,
  AcceptedFilesTitle,
  FileTypesList,
  FileTypeItem
} from '../style'

const RenderStepContent = ({
  activeStep,
  setActiveStep,
  file,
  setFile,
  campaignId,
  setCampaignId,
  campaigns,
  sendFile,
  loading,
  campaignAllSelected
}) => {
  const [isDragActive, setIsDragActive] = useState(false)
  const acceptedTypes = ['.xlsx', '.xls', '.csv']

  const onFilesChange = (files) => {
    setFile(files[0])
    setIsDragActive(false)
    if (campaignId > 0) {
      setActiveStep(3)
    }
  }

  const onFilesError = (error) => {
    console.error('Erro no upload:', error)
    setIsDragActive(false)
  }

  const removeFile = () => {
    setFile(null)
    setActiveStep(2)
  }

  const getFileIcon = (fileName) => {
    if (fileName?.includes('.xlsx') || fileName?.includes('.xls')) {
      return <FaFileExcel />
    } else if (fileName?.includes('.csv')) {
      return <FaFileCsv />
    }
    return <FaCloudUploadAlt />
  }

  const getFileType = (fileName) => {
    if (fileName?.includes('.xlsx') || fileName?.includes('.xls')) {
      return 'excel'
    } else if (fileName?.includes('.csv')) {
      return 'csv'
    }
    return 'default'
  }

  const handleCampaignSelect = (item) => {
    setCampaignId(item.id)
    if (file) {
      setActiveStep(3)
    } else {
      setActiveStep(2)
    }
  }

  switch (activeStep) {
    case 1:
      return (
        <StepContent active={activeStep === 1}>
          <ImportSection>
            <SectionTitle>
              <StepNumber>1</StepNumber>
              Escolha a Campanha
            </SectionTitle>

            <DropdownContainer>
              <Dropdown
                className="campaign-dropdown"
                campaignAllSelected={campaignAllSelected}
                onSelected={handleCampaignSelect}
                name="campaigns"
                items={campaign.toDropdown(
                  campaigns,
                  'Selecione uma campanha...'
                )}
              />
            </DropdownContainer>
          </ImportSection>
        </StepContent>
      )

    case 2:
      return (
        <StepContent active={activeStep === 2}>
          <ImportSection>
            <SectionTitle>
              <StepNumber>2</StepNumber>
              Envie seu arquivo
            </SectionTitle>

            <FileUploadContainer>
              <Files
                className="files-dropzone"
                onChange={onFilesChange}
                onError={onFilesError}
                accepts={acceptedTypes}
                multiple={false}
                maxFileSize={5000000}
                minFileSize={0}
                clickable
                onDragEnter={() => setIsDragActive(true)}
                onDragLeave={() => setIsDragActive(false)}
              >
                <FilesDropzone dragActive={isDragActive}>
                  <UploadZone>
                    <UploadZoneContent>
                      <BackupIcon style={{ fontSize: 60 }} color="primary" />

                      <UploadText>
                        <UploadTitle>
                          Clique para enviar ou arraste o arquivo
                        </UploadTitle>
                        <UploadSubtitle>
                          Formatos aceitos: XLS, XLSX, CSV (Máx. 5MB)
                        </UploadSubtitle>
                      </UploadText>
                    </UploadZoneContent>

                    {file && (
                      <FilePreview>
                        <FileIcon className={getFileType(file.name)}>
                          {getFileIcon(file.name)}
                        </FileIcon>
                        <FileInfo>
                          <FileName>{file.name}</FileName>
                        </FileInfo>
                        <RemoveFileButton
                          onClick={(e) => {
                            e.stopPropagation()
                            removeFile()
                          }}
                        >
                          <MdClose />
                        </RemoveFileButton>
                      </FilePreview>
                    )}
                  </UploadZone>
                </FilesDropzone>
              </Files>

              <AcceptedFilesInfo>
                <AcceptedFilesTitle>
                  Formatos de arquivo aceitos:
                </AcceptedFilesTitle>
                <FileTypesList>
                  <FileTypeItem>
                    <FaFileExcel style={{ color: '#217346' }} />
                    <span>Excel (.xlsx, .xls)</span>
                  </FileTypeItem>
                  <FileTypeItem>
                    <FaFileCsv style={{ color: '#0e83cd' }} />
                    <span>CSV (.csv)</span>
                  </FileTypeItem>
                </FileTypesList>
              </AcceptedFilesInfo>
            </FileUploadContainer>
          </ImportSection>
        </StepContent>
      )

    case 3:
      return (
        <StepContent active={activeStep === 3}>
          {loading ? (
            <LoadingContainer>
              <CircularProgress size={60} thickness={4} />
              <LoadingText>Processando seu arquivo...</LoadingText>
            </LoadingContainer>
          ) : (
            <ImportSection>
              <SectionTitle>
                <StepNumber>3</StepNumber>
                Revise e envie
              </SectionTitle>

              {file && campaignId > 0 && (
                <>
                  <FilePreview>
                    <FileIcon className={getFileType(file.name)}>
                      {getFileIcon(file.name)}
                    </FileIcon>
                    <FileInfo>
                      <FileName>{file.name}</FileName>
                    </FileInfo>
                  </FilePreview>

                  <UploadButton onClick={sendFile}>
                    Processar Arquivo
                  </UploadButton>
                </>
              )}
            </ImportSection>
          )}
        </StepContent>
      )

    default:
      return null
  }
}

export default RenderStepContent
